module.exports = __webpack_public_path__ + "static/img/3.64a57da.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/cooperation/imgs/3.png
// module id = 7oPO
// module chunks = 1